/* eslint-disable no-useless-escape */
const REGULARS = {
  ipAddress: /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/,
  ipAddressWidthMask: /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\/([1-9]|[1-2][0-9]|3[0-2])$/,
  password: /^(?=.*[A-Z])(?=.*\d)(?=.*[\\`~!@#$%^&*()_\-+={}[\]|:;"'<>,.?\/])[A-Za-z\d\\`~!@#$%^&*()_\-+={}[\]|:;"'<>,.?\/]{8,}$/,
  vmName: /^(?=(?:.*[a-zA-Z]){1})[a-zA-Z0-9-]+$/g,
  alfanumeric: /^[a-zA-Z0-9_-]+$/,
  noSpaces: /.*\S.*/g,
  dbUserName: /^[a-zA-Z][a-zA-Z0-9]+$/,
  dbInstanceName: /^[a-z][a-z0-9\-]+$/,
  vmUserTemplate: /^[a-z][a-z0-9\-_]+$/,
} as const;

export default REGULARS;
